// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gothic+A1&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.story_wrapper {
  width: 100%;
  height: 100%;
  padding: 0 0 100px 0;
}

.story_inner_div {
  width: 100%;
}

.story_slider_div {
  width: 100%;
}

.story_header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.story_heading {
  color: #fff;
  font-family: "Gothic A1";
  font-size: 54px;
  font-style: normal;
  font-weight: 800;
  line-height: 114%;
  border-bottom: 6px solid #206d23;
  padding: 0 150px 6px 97px;
  margin: 0 0 20px 0;
}

.story_slider_btns_div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 55px;
  gap: 13px;
}

.story_slider_btn {
  width: 38.857px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #bebebe;
  background: none;
}

.story_slider_btn_icon {
  color: #bebebe;
}

.story_cards {
  width: 100%;
  gap: 24px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0 0 97px;
}

.story_card {
  width: calc(100% - 24px) !important;
  height: 407px;
  margin: 0 12px;
  background-color: gray;
  border-radius: 12px;
  margin-top: 24px;
  position: relative;
}

.story_card_img_div {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.story_card_img_div > img {
  width: 100%;
  height: 100%;
}

.story_card_info_div {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 155px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;

  border-radius: 12px;
  background: rgba(11, 11, 11, 0.5);
  mix-blend-mode: hard-light;
}

.story_card_info_div > p {
  color: #fff;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.story_prev {
  margin-left: calc(100% - 100px);
  border: 1px solid #000;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.story_next {
  margin-top: -466px;
  margin-left: calc(100% - 60px);
  border: 1px solid #000;

  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.story_next:disabled {
  display: none;
}

.story_prev_arrow {
  /* font-size: 20px; */

  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.story_next_arrow {
  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1200px) {
  .story_wrapper {
    width: 100%;
    height: 100%;
    margin-top: 20px;
    padding: 0;
  }

  .story_inner_div {
    width: 100%;
    height: 100%;
    padding-bottom: 100px;
  }

  .story_slider_div {
    width: 100%;
    margin-top: 0;
  }

  .story_heading {
    width: 70% !important;
    font-size: 46px;
    border-bottom: 6px solid #206d23;
    padding: 0 100px 6px 50px;
    margin: 0 0 20px 0;
  }

  .story_slider_btns_div {
    width: 30%;
    padding-right: 30px;
    gap: 13px;
  }

  .story_slider_btn {
    width: 38px;
    height: 32px;
  }

  .story_cards {
    width: 100%;
    gap: 24px !important;
    padding: 0;
    margin: 0;
  }

  .story_card {
    width: calc(100% - 20px) !important;
    height: 407px;
    margin: 0 10px;
    border-radius: 12px;
    margin-top: 24px;
  }

  .story_card_img_div {
    width: 100%;
    height: 100%;
  }

  .story_card_info_div {
    width: 100%;
    height: 155px;
    padding: 0 10px;
    border-radius: 12px;
  }

  .story_card_info_div > p {
    font-size: 24px;
  }
}

@media screen and (max-width: 1024px) {
  .story_wrapper {
    width: 100%;
    height: 100%;
    margin-top: 20px;
    padding: 0;
  }

  .story_inner_div {
    width: 100%;
    height: 100%;
    padding-bottom: 100px;
  }

  .story_slider_div {
    width: 100%;
    margin-top: 0;
  }

  .story_heading {
    width: 60% !important;
    font-size: 42px;
    border-bottom: 6px solid #206d23;
    padding: 0 50px 6px 50px;
    margin: 0 0 20px 0;
  }

  .story_slider_btns_div {
    width: 40%;
    padding-right: 30px;
    gap: 13px;
  }

  .story_slider_btn {
    width: 38px;
    height: 32px;
  }

  .story_cards {
    width: 100%;
    gap: 16px !important;
  }

  .story_card {
    width: calc(100% - 20px) !important;
    height: 407px;
    margin: 0 10px;
    border-radius: 12px;
    margin-top: 24px;
  }

  .story_card_img_div {
    width: 100%;
    height: 100%;
  }

  .story_card_info_div {
    width: 100%;
    height: 130px;
    padding: 0 10px;
    border-radius: 12px;
  }

  .story_card_info_div > p {
    font-size: 22px;
  }
}

@media screen and (max-width: 800px) {
  .story_wrapper {
    width: 100%;
    height: 100%;
    margin-top: 0px;
    padding: 0;
  }

  .story_inner_div {
    width: 100%;
    height: 100%;
    padding-bottom: 100px;
  }

  .story_slider_div {
    width: 100%;
    margin-top: 0;
  }

  .story_heading {
    width: 60% !important;
    font-size: 36px;
    border-bottom: 6px solid #206d23;
    padding: 0 30px 6px 30px;
    margin: 0 0 20px 0;
  }

  .story_slider_btns_div {
    width: 40%;
    padding-right: 30px;
    gap: 13px;
  }

  .story_slider_btn {
    width: 38px;
    height: 32px;
  }

  .story_cards {
    width: 100%;
    gap: 16px !important;
  }

  .story_card {
    width: calc(100% - 16px) !important;
    height: 350px;
    margin: 0 8px;
    border-radius: 8px;
    margin-top: 24px;
  }

  .story_card_img_div {
    width: 100%;
    height: 100%;
  }

  .story_card_info_div {
    width: 100%;
    height: 130px;
    padding: 0 10px;
    border-radius: 12px;
  }

  .story_card_info_div > p {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .story_wrapper {
    width: 100%;
    height: 100%;
    margin-top: 0px;
    padding: 0;
  }

  .story_inner_div {
    width: 100%;
    height: 100%;
    padding-bottom: 50px;
  }

  .story_slider_div {
    width: 100%;
    margin-top: 0;
  }

  .story_heading {
    width: 70% !important;
    font-size: 30px;
    border-bottom: 4px solid #206d23;
    padding: 0 10px 6px 10px;
    margin: 0 0 10px 0;
  }

  .story_slider_btns_div {
    width: 30%;
    padding-right: 20px;
    gap: 13px;
  }

  .story_slider_btn {
    width: 38px;
    height: 32px;
  }

  .story_cards {
    width: 100%;
    gap: 16px !important;
  }

  .story_card {
    width: calc(100% - 16px) !important;
    height: 350px;
    margin: 0 8px;
    border-radius: 8px;
    margin-top: 24px;
  }

  .story_card_img_div {
    width: 100%;
    height: 100%;
  }

  .story_card_info_div {
    width: 100%;
    height: 130px;
    padding: 0 10px;
    border-radius: 12px;
  }

  .story_card_info_div > p {
    font-size: 18px;
  }
}

@media screen and (max-width: 450px) {
  .story_wrapper {
    width: 100%;
    height: 100%;
    margin-top: 0px;
    padding: 0;
  }

  .story_inner_div {
    width: 100%;
    height: 100%;
    padding-bottom: 50px;
  }

  .story_slider_div {
    width: 100%;
    margin-top: 0;
  }

  .story_heading {
    width: 70% !important;
    font-size: 24px;
    border-bottom: 4px solid #206d23;
    padding: 0 10px 6px 10px;
    margin: 0 0 10px 0;
  }

  .story_slider_btns_div {
    width: 30%;
    padding-right: 10px;
    gap: 13px;
  }

  .story_slider_btn {
    width: 30px;
    height: 30px;
  }

  .story_cards {
    width: 100%;
    gap: 16px !important;
  }

  .story_card {
    width: calc(100% - 8px) !important;
    height: 320px;
    margin: 0 4px;
    border-radius: 8px;
    margin-top: 24px;
  }

  .story_card_img_div {
    width: 100%;
    height: 100%;
  }

  .story_card_info_div {
    width: 100%;
    height: 130px;
    padding: 0 10px;
    border-radius: 12px;
  }

  .story_card_info_div > p {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/homePage/story/story.css"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;EAEf,mBAAmB;EACnB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;;EAEtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;;EAErB,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,mCAAmC;IACnC,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,mCAAmC;IACnC,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,mCAAmC;IACnC,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,mCAAmC;IACnC,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gothic+A1&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n.story_wrapper {\n  width: 100%;\n  height: 100%;\n  padding: 0 0 100px 0;\n}\n\n.story_inner_div {\n  width: 100%;\n}\n\n.story_slider_div {\n  width: 100%;\n}\n\n.story_header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.story_heading {\n  color: #fff;\n  font-family: \"Gothic A1\";\n  font-size: 54px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 114%;\n  border-bottom: 6px solid #206d23;\n  padding: 0 150px 6px 97px;\n  margin: 0 0 20px 0;\n}\n\n.story_slider_btns_div {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 55px;\n  gap: 13px;\n}\n\n.story_slider_btn {\n  width: 38.857px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #bebebe;\n  background: none;\n}\n\n.story_slider_btn_icon {\n  color: #bebebe;\n}\n\n.story_cards {\n  width: 100%;\n  gap: 24px !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 0 0 97px;\n}\n\n.story_card {\n  width: calc(100% - 24px) !important;\n  height: 407px;\n  margin: 0 12px;\n  background-color: gray;\n  border-radius: 12px;\n  margin-top: 24px;\n  position: relative;\n}\n\n.story_card_img_div {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.story_card_img_div > img {\n  width: 100%;\n  height: 100%;\n}\n\n.story_card_info_div {\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  height: 155px;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n\n  border-radius: 12px;\n  background: rgba(11, 11, 11, 0.5);\n  mix-blend-mode: hard-light;\n}\n\n.story_card_info_div > p {\n  color: #fff;\n  font-family: Roboto;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.story_prev {\n  margin-left: calc(100% - 100px);\n  border: 1px solid #000;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.story_next {\n  margin-top: -466px;\n  margin-left: calc(100% - 60px);\n  border: 1px solid #000;\n\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.story_next:disabled {\n  display: none;\n}\n\n.story_prev_arrow {\n  /* font-size: 20px; */\n\n  width: 30px;\n  height: 30px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.story_next_arrow {\n  width: 30px;\n  height: 30px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media screen and (max-width: 1200px) {\n  .story_wrapper {\n    width: 100%;\n    height: 100%;\n    margin-top: 20px;\n    padding: 0;\n  }\n\n  .story_inner_div {\n    width: 100%;\n    height: 100%;\n    padding-bottom: 100px;\n  }\n\n  .story_slider_div {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  .story_heading {\n    width: 70% !important;\n    font-size: 46px;\n    border-bottom: 6px solid #206d23;\n    padding: 0 100px 6px 50px;\n    margin: 0 0 20px 0;\n  }\n\n  .story_slider_btns_div {\n    width: 30%;\n    padding-right: 30px;\n    gap: 13px;\n  }\n\n  .story_slider_btn {\n    width: 38px;\n    height: 32px;\n  }\n\n  .story_cards {\n    width: 100%;\n    gap: 24px !important;\n    padding: 0;\n    margin: 0;\n  }\n\n  .story_card {\n    width: calc(100% - 20px) !important;\n    height: 407px;\n    margin: 0 10px;\n    border-radius: 12px;\n    margin-top: 24px;\n  }\n\n  .story_card_img_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .story_card_info_div {\n    width: 100%;\n    height: 155px;\n    padding: 0 10px;\n    border-radius: 12px;\n  }\n\n  .story_card_info_div > p {\n    font-size: 24px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .story_wrapper {\n    width: 100%;\n    height: 100%;\n    margin-top: 20px;\n    padding: 0;\n  }\n\n  .story_inner_div {\n    width: 100%;\n    height: 100%;\n    padding-bottom: 100px;\n  }\n\n  .story_slider_div {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  .story_heading {\n    width: 60% !important;\n    font-size: 42px;\n    border-bottom: 6px solid #206d23;\n    padding: 0 50px 6px 50px;\n    margin: 0 0 20px 0;\n  }\n\n  .story_slider_btns_div {\n    width: 40%;\n    padding-right: 30px;\n    gap: 13px;\n  }\n\n  .story_slider_btn {\n    width: 38px;\n    height: 32px;\n  }\n\n  .story_cards {\n    width: 100%;\n    gap: 16px !important;\n  }\n\n  .story_card {\n    width: calc(100% - 20px) !important;\n    height: 407px;\n    margin: 0 10px;\n    border-radius: 12px;\n    margin-top: 24px;\n  }\n\n  .story_card_img_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .story_card_info_div {\n    width: 100%;\n    height: 130px;\n    padding: 0 10px;\n    border-radius: 12px;\n  }\n\n  .story_card_info_div > p {\n    font-size: 22px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .story_wrapper {\n    width: 100%;\n    height: 100%;\n    margin-top: 0px;\n    padding: 0;\n  }\n\n  .story_inner_div {\n    width: 100%;\n    height: 100%;\n    padding-bottom: 100px;\n  }\n\n  .story_slider_div {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  .story_heading {\n    width: 60% !important;\n    font-size: 36px;\n    border-bottom: 6px solid #206d23;\n    padding: 0 30px 6px 30px;\n    margin: 0 0 20px 0;\n  }\n\n  .story_slider_btns_div {\n    width: 40%;\n    padding-right: 30px;\n    gap: 13px;\n  }\n\n  .story_slider_btn {\n    width: 38px;\n    height: 32px;\n  }\n\n  .story_cards {\n    width: 100%;\n    gap: 16px !important;\n  }\n\n  .story_card {\n    width: calc(100% - 16px) !important;\n    height: 350px;\n    margin: 0 8px;\n    border-radius: 8px;\n    margin-top: 24px;\n  }\n\n  .story_card_img_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .story_card_info_div {\n    width: 100%;\n    height: 130px;\n    padding: 0 10px;\n    border-radius: 12px;\n  }\n\n  .story_card_info_div > p {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .story_wrapper {\n    width: 100%;\n    height: 100%;\n    margin-top: 0px;\n    padding: 0;\n  }\n\n  .story_inner_div {\n    width: 100%;\n    height: 100%;\n    padding-bottom: 50px;\n  }\n\n  .story_slider_div {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  .story_heading {\n    width: 70% !important;\n    font-size: 30px;\n    border-bottom: 4px solid #206d23;\n    padding: 0 10px 6px 10px;\n    margin: 0 0 10px 0;\n  }\n\n  .story_slider_btns_div {\n    width: 30%;\n    padding-right: 20px;\n    gap: 13px;\n  }\n\n  .story_slider_btn {\n    width: 38px;\n    height: 32px;\n  }\n\n  .story_cards {\n    width: 100%;\n    gap: 16px !important;\n  }\n\n  .story_card {\n    width: calc(100% - 16px) !important;\n    height: 350px;\n    margin: 0 8px;\n    border-radius: 8px;\n    margin-top: 24px;\n  }\n\n  .story_card_img_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .story_card_info_div {\n    width: 100%;\n    height: 130px;\n    padding: 0 10px;\n    border-radius: 12px;\n  }\n\n  .story_card_info_div > p {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .story_wrapper {\n    width: 100%;\n    height: 100%;\n    margin-top: 0px;\n    padding: 0;\n  }\n\n  .story_inner_div {\n    width: 100%;\n    height: 100%;\n    padding-bottom: 50px;\n  }\n\n  .story_slider_div {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  .story_heading {\n    width: 70% !important;\n    font-size: 24px;\n    border-bottom: 4px solid #206d23;\n    padding: 0 10px 6px 10px;\n    margin: 0 0 10px 0;\n  }\n\n  .story_slider_btns_div {\n    width: 30%;\n    padding-right: 10px;\n    gap: 13px;\n  }\n\n  .story_slider_btn {\n    width: 30px;\n    height: 30px;\n  }\n\n  .story_cards {\n    width: 100%;\n    gap: 16px !important;\n  }\n\n  .story_card {\n    width: calc(100% - 8px) !important;\n    height: 320px;\n    margin: 0 4px;\n    border-radius: 8px;\n    margin-top: 24px;\n  }\n\n  .story_card_img_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .story_card_info_div {\n    width: 100%;\n    height: 130px;\n    padding: 0 10px;\n    border-radius: 12px;\n  }\n\n  .story_card_info_div > p {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
